import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import ForgotPasswordPage, { ResetPasswordPage } from './pages/ForgotPasswordPage';
import ProfileSettings from './pages/ProfileSettings';
import FAQPage from './pages/FAQPage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import WorkerDashboard from './pages/WorkerDashboard';
import EmployerDashboard from './pages/EmployerDashboard';
import MedicalDashboard from './pages/MedicalDashboard';
import AdminDashboard from './pages/AdminDashboard';
import './App.css';

function ProtectedRoute({ children, role }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <Layout>
                <div className="flex items-center justify-center h-[60vh]" data-testid="loading-screen">
                    <div className="w-8 h-8 border-2 border-zinc-900 border-t-transparent animate-spin" />
                </div>
            </Layout>
        );
    }
    if (!user) return <Navigate to="/auth" replace />;
    if (role && user.role !== role) return <Navigate to={`/${user.role}`} replace />;
    return <Layout>{children}</Layout>;
}

function AuthRedirect() {
    const { user, loading } = useAuth();
    if (loading) return null;
    if (user) return <Navigate to={`/${user.role}`} replace />;
    return <LandingPage />;
}

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Routes>
                    <Route path="/" element={<AuthRedirect />} />
                    <Route path="/auth" element={<AuthPage />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    <Route path="/reset-password" element={<ResetPasswordPage />} />
                    <Route path="/terms" element={<TermsPage />} />
                    <Route path="/privacy" element={<PrivacyPage />} />
                    <Route path="/worker" element={<ProtectedRoute role="worker"><WorkerDashboard /></ProtectedRoute>} />
                    <Route path="/employer" element={<ProtectedRoute role="employer"><EmployerDashboard /></ProtectedRoute>} />
                    <Route path="/medical" element={<ProtectedRoute role="medical"><MedicalDashboard /></ProtectedRoute>} />
                    <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
                    <Route path="/settings" element={<ProtectedRoute><ProfileSettings /></ProtectedRoute>} />
                    <Route path="/faq" element={<FAQPage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/verify-email" element={<VerifyEmailPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
